export enum LocalisationEntities {
	COMMON = "common",
	DATE = "date"
}

export enum SupportedLanguages {
	ENGLISH = "en",
	RUSSIAN = "ru"
}
